import React, { useState } from "react";
import { FaUserEdit, FaBell, FaLock, FaListAlt } from "react-icons/fa";
import "./adminprofile.css";

const AdminProfile = () => {
  const [admin, setAdmin] = useState({
    name: "John Doe",
    role: "Super Admin",
    email: "admin@example.com",
    contact: "+91 9876543210",
  });

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [notifications, setNotifications] = useState(true);
  const [activityLogs, setActivityLogs] = useState([
    "Approved a new user profile",
    "Updated membership plans",
    "Deleted a reported account",
    "Changed dashboard theme settings",
  ]);

  const handlePasswordChange = () => {
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    alert("Password Updated Successfully!");
    setPassword("");
    setConfirmPassword("");
  };

  return (
    <div className="admin-profilez11">
      {/* Profile Section */}
      <div className="profile-cardz11">
        <img src="https://via.placeholder.com/100" alt="Admin" className="profile-picz11" />
        <button className="edit-btnz11">
          <FaUserEdit /> Edit Profile
        </button>
        <h2 className="admin-namez11">{admin.name}</h2>
        <p className="admin-rolez11">{admin.role}</p>
        <p className="admin-emailz11">Email: {admin.email}</p>
        <p className="admin-contactz11">Contact: {admin.contact}</p>
      </div>

      {/* Change Password Section */}
      <div className="settings-cardz11">
        <h3 className="settings-titlez11"><FaLock /> Change Password</h3>
        <input type="password" className="input-fieldz11" placeholder="New Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <input type="password" className="input-fieldz11" placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        <button className="update-btnz11" onClick={handlePasswordChange}>Update Password</button>
      </div>

      {/* Notification Settings */}
      <div className="settings-cardz11">
        <h3 className="settings-titlez11"><FaBell /> Notification Settings</h3>
        <label className="notification-labelz11">
          <input type="checkbox" className="checkboxz11" checked={notifications} onChange={() => setNotifications(!notifications)} /> Enable Notifications
        </label>
      </div>

      {/* Activity Logs */}
      <div className="settings-cardz11">
        <h3 className="settings-titlez11"><FaListAlt /> Activity Logs</h3>
        <ul className="activity-logsz11">
          {activityLogs.map((log, index) => (
            <li key={index} className="activity-itemz11">{log}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminProfile;
